import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, isRouteErrorResponse, useRouteError } from 'react-router';

function StatusPage({ code, messageKey }: { code: string; messageKey: string }) {
  const { t } = useTranslation();
  return (
    <Stack spacing={2} sx={{ alignItems: 'center', justifyContent: 'center', py: 12 }}>
      <Typography variant="h2" color="text.disabled" sx={{ fontWeight: 700 }}>
        {code}
      </Typography>
      <Typography variant="h6">{t(messageKey)}</Typography>
      <Button component={RouterLink} to="/" variant="outlined">
        {t('actions.back')}
      </Button>
    </Stack>
  );
}

export const NotFoundPage = () => <StatusPage code="404" messageKey="pages.notFound" />;
export const ForbiddenPage = () => <StatusPage code="403" messageKey="pages.forbidden" />;

export function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  return <StatusPage code="!" messageKey="pages.error" />;
}
